import { useState } from "react";

type ModalHookProps = {
  isModalOpened: boolean;
  toggleModal: () => void;
  openModal: () => void;
  closeModal: () => void;
}

const useModal = (initialState?: boolean): ModalHookProps => {
  const [isModalOpened, setModalOpen] = useState<boolean>(initialState ?? false);
  const toggleModal = (): void => setModalOpen(!isModalOpened);
  const openModal = (): void => setModalOpen(true);
  const closeModal = (): void => setModalOpen(false);

  return { isModalOpened, toggleModal, openModal, closeModal };
};

export default useModal;